import { SetPasswordRequest, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useResendLink = () =>
  useMutationWithLoading(
    async (params: {
      linkType: string;
      setPasswordRequest: SetPasswordRequest;
      xTENANTID?: string;
    }) =>
      new UserControllerApi(getConfigObject()).sendEmailForForgotPassword(
        params?.linkType,
        params?.setPasswordRequest,
        params?.xTENANTID
      )
  );
